import type { AspidaClient, BasicHeaders } from 'aspida';
import { dataToURLString } from 'aspida';
import type { Methods as Methods_40a1g8 } from './api/job/v1/featureJobs/jobs';
import type { Methods as Methods_1mqqo2s } from './api/job/v1/featureJobs/jobs/count';
import type { Methods as Methods_4fam7f } from './api/job/v1/jobs';
import type { Methods as Methods_n7e6g6 } from './api/job/v1/jobs/_jobId@number';
import type { Methods as Methods_17lvc1f } from './api/job/v1/jobs/count';

const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? 'http://localhost:8080' : baseURL).replace(/\/$/, '');
  const PATH0 = '/api/job/v1/featureJobs/jobs';
  const PATH1 = '/api/job/v1/featureJobs/jobs/count';
  const PATH2 = '/api/job/v1/jobs';
  const PATH3 = '/api/job/v1/jobs/count';
  const GET = 'GET';
  const POST = 'POST';

  return {
    api: {
      job: {
        v1: {
          featureJobs: {
            jobs: {
              count: {
                /**
                 * 指定した検索条件で特集求人一覧件数を取得する
                 * @param option.body - 特集求人一覧検索条件リクエストボディ
                 * @returns 成功
                 */
                post: (option: { body: Methods_1mqqo2s['post']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_1mqqo2s['post']['resBody'], BasicHeaders, Methods_1mqqo2s['post']['status']>(prefix, PATH1, POST, option).json(),
                /**
                 * 指定した検索条件で特集求人一覧件数を取得する
                 * @param option.body - 特集求人一覧検索条件リクエストボディ
                 * @returns 成功
                 */
                $post: (option: { body: Methods_1mqqo2s['post']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_1mqqo2s['post']['resBody'], BasicHeaders, Methods_1mqqo2s['post']['status']>(prefix, PATH1, POST, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH1}`,
              },
              /**
               * 指定した検索条件で特集求人一覧を取得する
               * @param option.body - 特集求人一覧検索条件リクエストボディ
               * @returns 成功
               */
              post: (option: { body: Methods_40a1g8['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_40a1g8['post']['resBody'], BasicHeaders, Methods_40a1g8['post']['status']>(prefix, PATH0, POST, option).json(),
              /**
               * 指定した検索条件で特集求人一覧を取得する
               * @param option.body - 特集求人一覧検索条件リクエストボディ
               * @returns 成功
               */
              $post: (option: { body: Methods_40a1g8['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_40a1g8['post']['resBody'], BasicHeaders, Methods_40a1g8['post']['status']>(prefix, PATH0, POST, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH0}`,
            },
          },
          jobs: {
            _jobId: (val4: number) => {
              const prefix4 = `${PATH2}/${val4}`;

              return {
                /**
                 * 指定した案件IDから求人詳細情報を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_n7e6g6['get']['resBody'], BasicHeaders, Methods_n7e6g6['get']['status']>(prefix, prefix4, GET, option).json(),
                /**
                 * 指定した案件IDから求人詳細情報を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_n7e6g6['get']['resBody'], BasicHeaders, Methods_n7e6g6['get']['status']>(prefix, prefix4, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix4}`,
              };
            },
            count: {
              /**
               * 求人件数を取得する
               * @returns 成功
               */
              get: (option?: { query?: Methods_17lvc1f['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_17lvc1f['get']['resBody'], BasicHeaders, Methods_17lvc1f['get']['status']>(prefix, PATH3, GET, option).json(),
              /**
               * 求人件数を取得する
               * @returns 成功
               */
              $get: (option?: { query?: Methods_17lvc1f['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_17lvc1f['get']['resBody'], BasicHeaders, Methods_17lvc1f['get']['status']>(prefix, PATH3, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_17lvc1f['get']['query'] } | undefined) =>
                `${prefix}${PATH3}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
            /**
             * 指定した検索条件から求人一覧を取得する
             * @param option.body - 求人一覧検索条件リクエストボディ
             * @returns 成功
             */
            post: (option: { body: Methods_4fam7f['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_4fam7f['post']['resBody'], BasicHeaders, Methods_4fam7f['post']['status']>(prefix, PATH2, POST, option).json(),
            /**
             * 指定した検索条件から求人一覧を取得する
             * @param option.body - 求人一覧検索条件リクエストボディ
             * @returns 成功
             */
            $post: (option: { body: Methods_4fam7f['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_4fam7f['post']['resBody'], BasicHeaders, Methods_4fam7f['post']['status']>(prefix, PATH2, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH2}`,
          },
        },
      },
    },
  };
};

export type ApiInstance = ReturnType<typeof api>;
export default api;
